<div class="sidemenu">
    <ul class="sidemenu-view">
        <ng-container *ngFor="let nav of navData">
            <li class="navitems" [ngClass]="{ 'has-submenu': nav.title === 'Loan Management.' }">
                <a *ngIf="nav.title !== 'Loan Management.'" class="nav-link" [routerLink]="[nav.route]"
                    routerLinkActive="active" (click)="closeSubmenu()">
                    <div class="tooltipsview"><span class="nav_name">{{nav.title}} </span></div>
                </a>

                <!-- Custom clickable nav for Loan management -->
                <div class="nav-link" *ngIf="nav.title === 'Loan Management.'" routerLinkActive="active"
                    (click)="toggleSubmenu(nav.title)" [ngClass]="{ 'active': isActive(nav) }">
                    <div class="tooltipsview"><span class="nav_name">{{ nav.title }} </span></div>
                </div>

                <!-- Show submenu only for Loan Management -->
                <ul class="submenu-view" *ngIf="activeSubmenu === nav.title">
                    <li>
                        <a [routerLink]="['/loan-management/active-loans']" routerLinkActive="active">Active Loans.</a>
                    </li>
                    <li>
                        <a [routerLink]="['/loan-management/previous-loans']" routerLinkActive="active">Previous Loans.</a>
                    </li>
                </ul>

            </li>
        </ng-container>
    </ul>
</div>